module.exports = __webpack_public_path__ + "img/our-work-02.73524ae0.jpg";